import React from "react";
import { Pagination } from "antd";

// El itemRender personalizado se mantiene como lo solicitaste.
const itemRender = (_, type, originalElement) => {
  if (type === "prev" || type === "next") {
    return null; // No se renderizan las flechas de anterior/siguiente.
  }
  return originalElement;
};

/**
 * Componente Paginator controlado que utiliza Ant Design.
 * @param {object} props - Propiedades del componente.
 * @param {number} props.totalItems - El número total de registros a paginar.
 * @param {number} props.itemsPerPage - Registros por página.
 * @param {number} props.currentPage - La página activa actualmente.
 * @param {function} props.onPageChange - Callback que se ejecuta cuando el usuario cambia de página.
 */
const Paginator = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  // No renderizar el paginador si no hay suficientes items para paginar.
  if (totalItems <= itemsPerPage) {
    return null;
  }

  return (
    <div className="paginator-container" style={{ display: 'flex', justifyContent: 'center', padding: '1rem 0' }}>
      <Pagination
        current={currentPage}
        total={totalItems}
        pageSize={itemsPerPage}
        onChange={onPageChange} // onChange notifica al componente padre del cambio de página.
        itemRender={itemRender}
        showSizeChanger={false} // Se mantiene para ocultar el selector de tamaño.
        
      />
    </div>
  );
};

export default Paginator;